
export class PayerModel{
    cust_code:string
    payer_code:string
    payer_name1:string
    payer_name2:string
    payer_name3:string
    salesorg:string
    division:string
    distchannel:string
    cgcode:string
    affiliate_payer: boolean = false;
    mat_gr_4:string
    term: string //TIC0908546 payment term follow to payer
    payment_term_name: string;
    insertion_category_id: string // CCLIORDER-1469 Adhoc Customer
}


// WEBPACK FOOTER //
// ./src/models/customer/payer.model.ts